
import { useState } from "react";
import Menu from '../menu/Menu';
import HelpCenter from "./HelpCenter";



export default function HelpCenterScreen() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <HelpCenter onOpenMenu={() => setIsMenuOpen(true)} />
      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-white">
          <Menu isLoggedIn={true} onClose={() => setIsMenuOpen(false)} />
        </div>
      )}
    </>
  );
}